import React from 'react'
import Fragment from '../common/fragment'


function FragmentCN(props) {
  return (
    <Fragment pos="nnn" {...props}>
      <p>
Entre un basural, se ve el humo de las chimeneas. Los cielos parecen abiertos. Las
advertencias están escritas en las paredes, Lascaux de otras prehistorias, geologías
de estos valles cuyas tierras no han sido excavadas porque ni la roca tampoco las
piedras, ni los minerales, el agua subterránea. El humo se observa a lo lejos y los
alambres de púa y otras vallas, las fosas y estas trincheras. La basura entre las
malezas como si brotara de la tierra, un árbol a mano derecha, el agua de la lluvia
en el camino. Las nubes.
      </p>
    </Fragment>
  )
}


export default FragmentCN
